import { projectId } from '../firebaseConfig';

/*
    This program wraps HTTPS standard function (not callable function)
*/

export const sendPasswordResetLink = async (email, firstName, auth) => {

    try
    { 
        //Manual
        const idToken = await auth.currentUser.getIdToken();

        //console.log("idToken:"+idToken);

        //console.log("About to call function");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/sendPasswordResetLink", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { email: email, firstName: firstName } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        if (json.error)
        {
            throw json.error;
        }

        //End Manual
    } catch(error)
    {
        console.log("Error calling sendPasswordResetLink function:"+error);
        throw error;
    }
};

export const createUser = async (email, password , firstName, lastName, role, appUserAccountNumber, appUserEmail, auth) => {

    try
    { 
        //Manual
        const idToken = await auth.currentUser.getIdToken();

        //console.log("idToken:"+idToken);

        //console.log("About to call function");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/createUser", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { email, password , firstName, lastName, role, appUserAccountNumber, appUserEmail } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        if (json.error)
        {
            throw json.error;
        }

        //End Manual
    } catch(error)
    {
        console.log("Error calling createUser function:"+error);
        throw error;
    }
};

export const createStripeSession = async (email, name, phone, plan, frequency, companyName, accountNumber, auth) => {

    try
    { 
        //Manual
        const idToken = await auth.currentUser.getIdToken();

        //console.log("idToken:"+idToken);
        //console.log("About to call function:");
        //console.log("https://us-central1-"+projectId+".cloudfunctions.net/createStripeSession");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/createStripeSession", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { email, name, phone, plan, frequency, companyName, accountNumber } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling createStripeSession function:"+error);
        throw error;
    }
};

export const createDodopaymentsSession = async (email, name, phone, plan, frequency, companyName, accountNumber, auth) => {

    try
    { 
        //Manual
        const idToken = await auth.currentUser.getIdToken();

        //console.log("idToken:"+idToken);
        //console.log("About to call function:");
        //console.log("https://us-central1-"+projectId+".cloudfunctions.net/createStripeSession");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/createDodopaymentsSession", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { email, name, phone, plan, frequency, companyName, accountNumber } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling createDodopaymentsSession function:"+error);
        throw error;
    }
};

export const createSignUpUserAccount = async (name, email, userSystemInfo, marketingOptInChecked, marketingOptInAgreementLabel, auth) => {

    try
    { 
        //Manual
        const idToken = await auth.currentUser.getIdToken();

        //console.log("idToken:"+idToken);
        //console.log("About to call function:");
        //console.log("https://us-central1-"+projectId+".cloudfunctions.net/createSignUpUserAccount");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/createSignUpUserAccount", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { name, email, userSystemInfo, marketingOptInChecked, marketingOptInAgreementLabel} })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling createSignUpUserAccount function:"+error);
        throw error;
    }
};


export const sendPPCSignupEmails = async (name, email, paymentProcessor,source) => {

    try
    { 
       
        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/sendPPCSignupEmails", {
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ data: { name, email, paymentProcessor,source} })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling sendPPCSignupEmails function:"+error);
        throw error;
    }
};


export const isUserAccountDeleted = async (email, auth) => {

    try
    { 
        //Manual
        const idToken = await auth.currentUser.getIdToken();

        //console.log("idToken:"+idToken);
        //console.log("About to call function:");
        //console.log("https://us-central1-"+projectId+".cloudfunctions.net/isUserAccountDeleted");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/isUserAccountDeleted", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { email } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json.isDeleted;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling isUserAccountDeleted function:"+error);
        throw error;
    }
};


export const doesUserWithEmailAlreadyExist = async (email) => {

    try
    {   
        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/doesUserWithEmailAlreadyExist", {
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ data: { email } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json.userExists;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling doesUserWithEmailAlreadyExist function:"+error);
        throw error;
    }
};

export const confirmDoubleOptIn = async (token) => {

    try
    {   
        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/confirmDoubleOptIn", {
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ data: { token } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json.success;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling confirmDoubleOptIn function:"+error);
        throw error;
    }
};

export const resendDoubleOptInEmail = async (token) => {

    try
    {   
        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/resendDoubleOptInEmail", {
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ data: { token } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json.success;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling resendDoubleOptInEmail function:"+error);
        throw error;
    }
};

export const optOutOfMarketingEmails = async (email) => {

    try
    {   
        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/optOutOfMarketingEmails", {
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ data: { email } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json.success;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling optOutOfMarketingEmails function:"+error);
        throw error;
    }
};

export const optOutOfPPCMarketingEmails = async (email) => {

    try
    {   
        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/optOutOfPPCMarketingEmails", {
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ data: { email } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json.success;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling optOutOfPPCMarketingEmails function:"+error);
        throw error;
    }
};

export const doesUserWithEmailAndPasswordLoginExist = async (email, auth) => {

    try
    { 
        console.log("ABOUT TO CALL doesUserWithEmailAndPasswordLoginExist");

        //Manual
        const idToken = await auth.currentUser.getIdToken();

        //console.log("idToken:"+idToken);
        //console.log("About to call function:");
        //console.log("https://us-central1-"+projectId+".cloudfunctions.net/doesUserWithEmailAndPasswordLoginExist");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/doesUserWithEmailAndPasswordLoginExist", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { email } })
        });

        console.log("CAME BACK FROM doesUserWithEmailAndPasswordLoginExist");
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json.userExists;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling doesUserWithEmailAndPasswordLoginExist function:"+error);
        throw error;
    }
};

export const hasUserEmailBeenVeridied = async (email, auth) => {

    try
    { 
        console.log("ABOUT TO CALL hasUserEmailBeenVeridied");

        //Manual
        const idToken = await auth.currentUser.getIdToken();

        //console.log("idToken:"+idToken);
        //console.log("About to call function:");
        //console.log("https://us-central1-"+projectId+".cloudfunctions.net/doesUserWithEmailAndPasswordLoginExist");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/hasUserEmailBeenVeridied", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { email } })
        });

        console.log("CAME BACK FROM hasUserEmailBeenVeridied");
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json.emailIsVerified;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling hasUserEmailBeenVeridied function:"+error);
        throw error;
    }
};

export const completeSuccessfulSubscription = async (sessionId, customerId, subscriptionId, auth) => {

    try
    { 
        console.log("ABOUT TO CALL doesUserWithEmailAndPasswordLoginExist");

        //Manual
        const idToken = await auth.currentUser.getIdToken();

        console.log("idToken:"+idToken);
        console.log("About to call function:");
        console.log("https://us-central1-"+projectId+".cloudfunctions.net/completeSuccessfulSubscription");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/completeSuccessfulSubscription", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { sessionId, customerId, subscriptionId } })
        });

        console.log("CAME BACK FROM completeSuccessfulSubscription");
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling doesUserWithEmailAndPasswordLoginExist function:"+error);
        throw error;
    }
};

export const completeSuccessfulDodoPaymentsSubscription = async (accountNumber, customerId, subscriptionId, auth) => {

    try
    { 
        console.log("ABOUT TO CALL doesUserWithEmailAndPasswordLoginExist");

        //Manual
        const idToken = await auth.currentUser.getIdToken();

        console.log("idToken:"+idToken);
        console.log("About to call function:");
        console.log("https://us-central1-"+projectId+".cloudfunctions.net/completeSuccessfulSubscription");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/completeSuccessfulDodoPaymentsSubscription", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { accountNumber, customerId, subscriptionId } })
        });

        console.log("CAME BACK FROM completeSuccessfulDodoPaymentsSubscription");
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling doesUserWithEmailAndPasswordLoginExist function:"+error);
        throw error;
    }
};


export const wasUserAccountCreatedDuringSignUp = async (email, auth) => {

    try
    { 
        //Manual
        const idToken = await auth.currentUser.getIdToken();

        //console.log("idToken:"+idToken);
        //console.log("About to call function:");
        //console.log("https://us-central1-"+projectId+".cloudfunctions.net/wasUserAccountCreatedDuringSignUp");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/wasUserAccountCreatedDuringSignUp", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { email } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json.wasCreatedAtSignUp;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling wasUserAccountCreatedDuringSignUp function:"+error);
        throw error;
    }
};


export const createStripeCustomerPortalSession = async (customerId, returnURL, auth) => {

    try
    { 
        //Manual
        const idToken = await auth.currentUser.getIdToken();

        //console.log("idToken:"+idToken);
        //console.log("About to call function:");
        //console.log("https://us-central1-"+projectId+".cloudfunctions.net/createStripeSession");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/createStripeCustomerPortalSession", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { customerId, returnURL } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling createStripeCustomerPortalSession function:"+error);
        throw error;
    }
};

export const createDodoPaymentsCustomerPortalSession = async (customerId, returnURL, auth) => {

    try
    { 
        //Manual
        const idToken = await auth.currentUser.getIdToken();

        //console.log("idToken:"+idToken);
        //console.log("About to call function:");
        //console.log("https://us-central1-"+projectId+".cloudfunctions.net/createStripeSession");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/createDodoPaymentsCustomerPortalSession", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { customerId, returnURL } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling createDodoPaymentsCustomerPortalSession function:"+error);
        throw error;
    }
};

export const createPaddleCustomerPortalSession = async (customerId, subscriptionId, auth) => {

    try
    { 
        const idToken = await auth.currentUser.getIdToken();

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/createPaddleCustomerPortalSession", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { customerId, subscriptionId} })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling createPaddleCustomerPortalSession function:"+error);
        throw error;
    }
};

export const getStripeSessionDetails = async (sessionId, auth) => {

    try
    { 
        //Manual
        const idToken = await auth.currentUser.getIdToken();

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/getStripeSessionDetails", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { sessionId } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling getStripeSessionDetails function:"+error);
        throw error;
    }
};

export const getDodoSessionDetails = async (sessionId, auth) => {

    try
    { 
        //Manual
        const idToken = await auth.currentUser.getIdToken();

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/getDodoSessionDetails", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { sessionId } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling getDodoSessionDetails function:"+error);
        throw error;
    }
};

export const getDodoSubscriptionDetails = async (subscriptionId, auth) => {

    try
    { 
        //Manual
        const idToken = await auth.currentUser.getIdToken();

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/getDodoSubscriptionDetails", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
            },
            body: JSON.stringify({ data: { subscriptionId } })
        });
        
        const json = await res.json();
        //console.log("Function response:", json);

        return json;
        
        //End Manual
    } catch(error)
    {
        console.log("Error calling getDodoSubscriptionDetails function:"+error);
        throw error;
    }
};



export const sendContactEmail = async (name, email, topic, message) => {

    try
    { 
        console.log("ABOUT call sendContactEmail");

        console.log("About to call function:");
        console.log("https://us-central1-"+projectId+".cloudfunctions.net/sendContactEmail");

        const res = await fetch("https://us-central1-"+projectId+".cloudfunctions.net/sendContactEmail", {
            method: "POST",
           headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          email,
          topic,
          message
        })
      });

        console.log("CAME BACK FROM sendContactEmail");
        
//        const json = await res.json();

        console.log(res);

  //      return json;
    
            return;
        //End Manual
    } catch(error)
    {
        console.log("Error calling sendContactEmail function:"+error);
        throw error;
    }
};